<div class="grid" *ngIf="vm$ | async as vm">
  <header class="grid__col-12 guts-p-t-0 guts-p-b-4">
    <dgx-pathway-header *ngIf="vm.pathway"></dgx-pathway-header>
  </header>
  <div *ngIf="!!tabList" class="grid__col-12 grid__col--bleed">
    <dgx-tab-navigation [tabList]="tabList"></dgx-tab-navigation>
  </div>
  <div class="grid__col-12 grid__col--bleed">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- TODO: Add a loader here?-->

<div class="footer-glasses"></div>
